export default __webpack_public_path__ + "static/media/n1.2.f0a84a03.jpg";